/**
 *
 * @description Function removes empty attributes from passed object
 *
 */
export function removeEmptyAttributes(obj: any) {
  for (const key in obj) {
    if (obj[key] === undefined) {
      delete obj[key];
    } else if (typeof obj[key] === 'object') {
      removeEmptyAttributes(obj[key]);
    }
  }
  return obj;
}
